import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'found';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  font-size: 13px;
  align-items: center;
  margin-bottom: 60px;
`;

const LinkCrumb = styled(Link)`
  color: #5c6ef8;
  text-decoration: none;
  font-weight: 500;
  &:hover {
    color: #4d5cce;
  }
`;

const Crumb = styled.div`
  color: #9092c1;
  font-weight: 500;
`;

const Arrow = styled.div`
  padding: 0px 12px;
  font-size: 8px;
  color: #9092c1;
`;

export type Crumb = {
  text: string;
  link?: string;
};

type Props = {
  crumbs: Crumb[];
};

function Breadcrumb({ crumbs }: Props) {
  const addArrow = (i: number) =>
    i !== crumbs.length - 1 && (
      <Arrow>
        <FontAwesomeIcon icon={faChevronRight} />
      </Arrow>
    );

  return (
    <Container>
      {crumbs.map((crumb, i) =>
        crumb.link ? (
          <>
            <LinkCrumb key={crumb.text} to={crumb.link}>
              {crumb.text}
            </LinkCrumb>
            {addArrow(i)}
          </>
        ) : (
          <>
            <Crumb key={crumb.text}>{crumb.text}</Crumb>
            {addArrow(i)}
          </>
        )
      )}
    </Container>
  );
}

export default Breadcrumb;
